import http from '@/utils/http';
const call=async(action,data)=>{const res=await http({url:'/api/admin/v1/contractProjectOrderTransportRevision/'+action,method:'post',data});if(res?.code!==0)throw Error(res?.msg||res?.message||'运输改线处理失败');return res.data;};
export default Object.fromEntries(['detail','plan','recordCustody'].map(action=>[action,data=>call(action,data)]));
